import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { AuthService, BASE_API_URL, IAuthTokenUser } from '@cnt-workspace/data-access';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

// Copy of cnt-landing's apps/cnt-landing/src/app/interceptors/jwt.interceptor.ts
// (that one lives in the app folder, not a lib, so it can't be imported here).
// Attaches the Cognito id token from AuthService to calls to our own API,
// renewing first if it's expired or within 30s of expiring.
const attachAuthHeader = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  auth: AuthService,
): Observable<HttpEvent<unknown>> => {
  return auth.authSession$.pipe(
    first(),
    switchMap((currentUser: IAuthTokenUser | undefined) => {
      if (currentUser && (!currentUser.authExpires || currentUser.authExpires < DateTime.now().toMillis() + 30000)) {
        setTimeout(() => auth.triggerRenew());
        return auth.renewResult$.pipe(
          first(),
          switchMap(() => attachAuthHeader(request, next, auth)),
        );
      } else if (currentUser?.authIdToken) {
        return next(request.clone({ setHeaders: { Authorization: currentUser.authIdToken } }));
      }
      return next(request);
    }),
  );
};

export const adminJwtInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId) && request.url.includes(BASE_API_URL)) {
    return attachAuthHeader(request, next, auth);
  }

  return next(request);
};
